var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5113 19.4999C19.5113 19.7651 19.4059 20.0195 19.2184 20.207C19.0308 20.3946 18.7765 20.4999 18.5113 20.4999H4.51127C4.24605 20.4999 3.9917 20.3946 3.80416 20.207C3.61663 20.0195 3.51127 19.7651 3.51127 19.4999V10.4999H0.511269L10.8383 1.11192C11.0224 0.944398 11.2624 0.851562 11.5113 0.851562C11.7602 0.851563 12.0002 0.944398 12.1843 1.11192L22.5113 10.4999H19.5113V19.4999ZM10.5113 12.4999V18.4999H12.5113V12.4999H10.5113Z",
    fill: "#3C1FAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBar);
export default __webpack_public_path__ + "static/media/HomeBar.8c897385f38cdba0c26ae413d128e935.svg";
export { ForwardRef as ReactComponent };